var _rect, _path, _path2, _path3, _path4, _path5, _path6, _line, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZagLogo2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 285,
    height: 100,
    viewBox: "0 0 285 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 285,
    height: 100,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M221.216 40.6324C219.147 43.5985 216.75 44.1424 213.867 42.3059C213.902 44.0831 213.588 45.6898 212.421 47.0865C210.08 49.8873 205.047 50.8291 201.913 48.9529C199.802 47.6872 198.873 45.7047 198.927 43.3464C198.962 41.8091 199.365 40.2814 199.619 38.6499L201.35 38.9416C201.209 39.8859 201.011 40.7733 200.954 41.6608C200.776 44.4786 201.757 46.2905 203.844 47.1187C206.212 48.0605 209.673 47.3955 211.089 45.5737C211.561 44.9223 211.811 44.1362 211.801 43.3316C211.613 37.2507 211.334 31.1724 211.089 25.094C211.064 24.4809 211.089 23.858 211.089 23.1782L213.103 23.0225C213.183 24.8443 213.267 26.6019 213.336 28.3568C213.454 31.4294 213.548 34.5046 213.687 37.5746C213.771 39.4706 214.641 40.5904 216.099 40.7881C218.117 41.0749 219.615 40.2517 220.21 38.4299C220.512 37.5078 220.665 36.5363 220.895 35.5352H222.47C222.47 36.4251 222.39 37.3372 222.492 38.2296C222.593 39.122 223.179 39.829 224.071 40.2666C225.035 39.0306 225.945 37.7748 226.969 36.6105C228.451 34.9199 230.182 33.5257 232.37 32.8311C235.138 31.9535 237.889 32.9027 239.237 35.1792C240.584 37.4559 240.141 39.9032 237.912 41.3592C236.866 42.0439 235.652 42.6767 234.451 42.8646C231.999 43.2549 229.518 43.446 227.035 43.4354C224.734 43.4478 222.477 42.9808 221.216 40.6324ZM225.839 40.8129C226.347 40.9246 226.864 40.9955 227.384 41.0255C229.344 40.9834 231.319 41.0255 233.257 40.7783C234.547 40.5914 235.795 40.1852 236.947 39.5769C238.542 38.7586 238.678 37.2977 237.383 36.0395C235.88 34.5788 234.07 34.4008 232.192 35.1275C229.416 36.2026 227.535 38.2865 225.839 40.8129Z",
    fill: "#231F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M246.472 48.0944C251.213 49.8471 255.101 47.9832 256.159 43.4548C255.23 43.3583 254.293 43.3163 253.378 43.1556C249.579 42.4783 247.972 38.5429 250.212 35.4458C251.989 32.9861 255.269 33.0306 256.982 35.5397C257.902 36.8817 258.189 38.4144 258.344 39.989C258.369 40.2362 258.376 40.4983 258.404 40.9432C260.312 40.827 262.163 40.7331 264.01 40.5922C264.905 40.523 265.295 39.9693 265.043 39.109C264.549 37.428 263.99 35.7622 263.444 34.0985C263.306 33.7668 263.145 33.4457 262.962 33.1369L264.966 32.3311C266.282 35.206 267.256 38.0905 266.783 41.2547C266.719 41.6898 266.311 42.2979 265.931 42.4215C264.668 42.8484 263.367 43.149 262.045 43.3188C260.789 43.4646 259.501 43.3509 258.201 43.3509C257.664 45.6274 256.75 47.6248 255.024 49.1648C252.822 51.1424 250.291 51.5725 247.53 50.648C245.908 50.1042 245.809 49.7779 246.472 48.0944ZM256.505 41.0742C256.409 39.1683 256.206 37.6332 254.987 36.4491C254.268 35.7523 253.413 35.5174 252.459 35.9028C251.504 36.2885 251.077 37.0647 251.032 38.0584C250.988 39.0521 251.43 39.9272 252.394 40.2189C253.68 40.6046 255.029 40.7776 256.505 41.0742Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M245.827 43.34H243.753C243.493 36.6437 243.234 29.9668 242.972 23.2037L245.04 23.0381C245.3 29.8185 245.562 36.5324 245.827 43.34Z",
    fill: "#231F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M260.767 26.1069C261.572 26.1069 262.141 26.6752 262.168 27.5305C262.195 28.4477 261.644 29.0434 260.777 29.0385C260.589 29.0461 260.403 29.015 260.228 28.947C260.053 28.8793 259.895 28.7762 259.762 28.6439C259.629 28.5119 259.524 28.354 259.455 28.1799C259.386 28.0057 259.354 27.8193 259.36 27.6319C259.34 26.742 259.919 26.1168 260.767 26.1069Z",
    fill: "#231F20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M264.574 29.0312C263.746 29.0486 263.197 28.4948 263.174 27.6173C263.152 26.7397 263.691 26.1341 264.492 26.1044C265.34 26.0698 265.953 26.6878 265.953 27.5876C265.964 27.7747 265.937 27.9621 265.872 28.1379C265.808 28.3139 265.708 28.4748 265.578 28.6103C265.449 28.7457 265.293 28.853 265.12 28.9254C264.947 28.9979 264.761 29.034 264.574 29.0312Z",
    fill: "#231F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M195.197 77.4054V65.1641H191.024V63.7402H200.912V65.1641H196.779V77.4054H195.197ZM202.225 77.4054L205.962 63.7402H209.384L213.101 77.4054H211.519L210.55 73.9446H204.776L203.807 77.4054H202.225ZM205.112 72.5405H210.214L208.177 65.085H207.149L205.112 72.5405ZM217.486 77.4054L214.737 63.7402H216.379L218.673 76.0211H219.226L221.995 63.8391H223.854L226.623 76.0211H227.176L229.47 63.7402H231.112L228.343 77.4054H225.495L222.786 65.1048H223.063L220.354 77.4054H217.486ZM232.747 77.4054L236.485 63.7402H239.906L243.624 77.4054H242.042L241.073 73.9446H235.298L234.329 77.4054H232.747ZM235.634 72.5405H240.736L238.699 65.085H237.671L235.634 72.5405ZM250.065 77.5834C249.669 77.5834 249.208 77.5569 248.681 77.5043C248.153 77.4647 247.626 77.4121 247.098 77.3461C246.584 77.267 246.129 77.201 245.734 77.1483L245.892 75.8431C246.274 75.8826 246.716 75.9289 247.217 75.9815C247.731 76.0342 248.232 76.0804 248.72 76.12C249.221 76.1595 249.643 76.1793 249.986 76.1793C250.948 76.1793 251.667 75.9617 252.141 75.5267C252.616 75.0916 252.853 74.4126 252.853 73.4898C252.853 72.9887 252.754 72.5932 252.557 72.3032C252.372 71.9999 252.056 71.7626 251.607 71.5913C251.172 71.4066 250.585 71.242 249.847 71.0969C248.898 70.8991 248.107 70.6685 247.474 70.4047C246.855 70.1279 246.387 69.739 246.07 69.2379C245.767 68.7369 245.615 68.0581 245.615 67.201C245.615 66.3178 245.793 65.6058 246.149 65.0652C246.518 64.5246 247.033 64.1291 247.692 63.8787C248.364 63.6283 249.142 63.5029 250.025 63.5029C250.421 63.5029 250.869 63.5294 251.37 63.582C251.884 63.6216 252.385 63.6742 252.873 63.7402C253.374 63.7929 253.803 63.8522 254.158 63.9182L254.02 65.2432C253.638 65.1906 253.196 65.1443 252.695 65.1048C252.194 65.0521 251.713 65.0059 251.251 64.9663C250.79 64.9268 250.421 64.907 250.144 64.907C249.181 64.907 248.45 65.085 247.949 65.441C247.461 65.7969 247.217 66.3507 247.217 67.1021C247.217 67.6823 247.322 68.1238 247.534 68.4271C247.758 68.7304 248.113 68.9678 248.601 69.1391C249.089 69.3104 249.729 69.4884 250.52 69.673C251.205 69.8312 251.792 70.0025 252.28 70.1872C252.781 70.3718 253.189 70.6025 253.506 70.8793C253.835 71.1431 254.073 71.4793 254.218 71.8879C254.376 72.2834 254.455 72.7778 254.455 73.3711C254.455 74.373 254.277 75.1838 253.921 75.8035C253.565 76.4233 253.057 76.8781 252.398 77.1681C251.739 77.4449 250.961 77.5834 250.065 77.5834ZM262.306 77.6031C261.304 77.6031 260.447 77.458 259.735 77.1681C259.023 76.8781 258.476 76.4166 258.094 75.7838C257.725 75.1378 257.54 74.2875 257.54 73.2327V63.7402H259.122V73.2722C259.122 74.3137 259.399 75.0652 259.953 75.5267C260.519 75.9748 261.304 76.1991 262.306 76.1991C263.361 76.1991 264.172 75.9748 264.738 75.5267C265.305 75.0652 265.589 74.3137 265.589 73.2722V63.7402H267.171V73.2327C267.171 74.2741 266.98 75.1181 266.597 75.764C266.228 76.4099 265.681 76.8781 264.956 77.1681C264.231 77.458 263.347 77.6031 262.306 77.6031ZM270.978 77.4054V63.7402H272.56V75.9815H278.533V77.4054H270.978Z",
    fill: "#D71921"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 89.252,
    y1: 88,
    x2: 89.252,
    y2: 11.5021,
    stroke: "black",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M122.044 72.9716C115.14 66.0657 111.941 56.8327 112.468 47.7873C112.913 40.0107 116.101 32.3633 122.044 26.424C130.265 18.1995 141.763 15.2337 152.346 17.5313C148.49 15.8552 144.294 14.9292 139.87 14.9292C123.327 14.9292 109.649 27.9333 107.44 44.8106C107.317 45.8013 107.229 46.7912 107.17 47.7873C106.66 58.1894 110.376 68.7581 118.311 76.7014C130.664 89.0342 149.346 91.1705 163.868 83.098C149.504 89.4945 132.627 83.5318 122.044 72.9716Z",
    fill: "#231F20"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M183.523 49.7387C183.523 49.1118 183.499 48.4848 183.464 47.8664L183.481 47.8633C183.036 38.7012 179.326 29.6792 172.329 22.6853C159.988 10.3462 141.305 8.21926 126.778 16.2973C141.153 9.90698 158.03 15.8604 168.602 26.4237C168.602 26.412 168.602 26.412 168.602 26.4237C174.562 32.3864 177.762 40.0571 178.201 47.8633C178.688 56.8884 175.494 66.0685 168.602 72.9713C160.38 81.1934 148.888 84.1553 138.298 81.864C142.143 83.54 146.356 84.4661 150.774 84.4661C167.306 84.4661 180.99 71.4798 183.193 54.6057C183.404 52.9911 183.521 51.3533 183.521 49.7271V49.7387H183.523Z",
    fill: "#231F20"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M142.208 73.7536C142.208 72.0222 143.609 70.6328 145.32 70.6328C147.043 70.6328 148.443 72.0215 148.443 73.7536C148.443 75.4826 147.043 76.8681 145.32 76.8681C143.61 76.8681 142.208 75.4826 142.208 73.7536Z",
    fill: "url(#paint0_radial_1646_251)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M142.947 66.9585C142.947 65.6547 144.019 64.5908 145.321 64.5908C146.645 64.5908 147.712 65.6547 147.712 66.9585C147.712 68.2801 146.645 69.3432 145.321 69.3432C144.019 69.344 142.947 68.2801 142.947 66.9585Z",
    fill: "url(#paint1_radial_1646_251)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M138.434 57.7281C138.299 64.4759 134.813 72.191 130.365 76.8679H138.891C141.529 69.455 143.392 62.1939 144.558 56.2514L144.582 53.978L138.434 57.7281Z",
    fill: "url(#paint2_linear_1646_251)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M160.287 66.3661C160.287 64.9541 159.133 63.8076 157.733 63.8076C156.321 63.8076 155.177 64.9533 155.177 66.3661C155.177 67.7781 156.32 68.9238 157.733 68.9238C159.133 68.9245 160.287 67.7789 160.287 66.3661Z",
    fill: "url(#paint3_radial_1646_251)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M135.481 66.3661C135.481 64.9541 134.327 63.8076 132.92 63.8076C131.502 63.8076 130.365 64.9533 130.365 66.3661C130.365 67.7781 131.502 68.9238 132.92 68.9238C134.327 68.9245 135.481 67.7789 135.481 66.3661Z",
    fill: "url(#paint4_radial_1646_251)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M147.395 49.9727C146.721 50.0054 146.018 50.0139 145.32 50.0139C145.044 50.0139 144.763 50.0139 144.494 50.0139L144.376 51.2507L144.452 52.5015C144.74 52.5101 145.033 52.5101 145.32 52.5101C146.017 52.5101 146.72 52.4898 147.395 52.4517V49.9727Z",
    fill: "url(#paint5_linear_1646_251)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M147.395 51.8247C146.721 51.8777 146.018 51.9041 145.32 51.9041C145.032 51.9041 144.74 51.9041 144.452 51.8893V53.2515C144.74 53.2663 145.032 53.2663 145.32 53.2663C146.017 53.2663 146.72 53.2484 147.395 53.2017V51.8247Z",
    fill: "#810000"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M143.931 20.542L140.075 56.2397C139.448 63.067 135.305 71.7431 130.365 76.8678H138.891C141.529 69.4549 143.392 62.1939 144.558 56.2514L145.32 20.542H143.931Z",
    fill: "url(#paint6_linear_1646_251)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M144.664 20.5537L143.351 56.2514C142.272 61.7749 140.303 68.4409 137.877 75.3063L130.365 76.8678H138.891C141.529 69.4549 143.392 62.1939 144.558 56.2514L145.32 21.9423V20.542L144.664 20.5537Z",
    fill: "url(#paint7_linear_1646_251)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M145.321 20.542H143.931L144.629 21.7087L145.321 20.542Z",
    fill: "url(#paint8_linear_1646_251)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M140.82 49.753C139.729 49.6151 138.645 49.4423 137.585 49.2109C137.544 51.8543 135.727 56.3692 130.365 57.3271V63.0321C134.919 61.3677 138.405 57.465 139.5 52.6619C139.835 52.7383 140.174 52.8029 140.503 52.8613L143.497 51.8535L140.82 49.753Z",
    fill: "url(#paint9_linear_1646_251)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M143.497 51.8537C141.763 51.7509 140.327 51.4931 138.704 51.0889C138.223 56.5539 134.707 61.0486 130.365 63.0112V63.0322C134.924 61.3679 138.405 57.4652 139.5 52.6621C139.835 52.7384 140.174 52.7968 140.514 52.8615L143.497 51.8537Z",
    fill: "#7D0000"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M152.206 57.7281C152.353 64.4759 155.84 72.191 160.287 76.8679H151.755C149.135 69.455 147.26 62.1939 146.094 56.2514L146.064 53.978L152.206 57.7281Z",
    fill: "url(#paint10_linear_1646_251)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M146.721 20.542L150.577 56.2397C151.21 63.067 155.336 71.7431 160.288 76.8678H151.755C149.135 69.4549 147.26 62.1939 146.094 56.2514L145.321 20.542H146.721Z",
    fill: "url(#paint11_linear_1646_251)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M145.983 20.5537L147.301 56.2514C148.38 61.7749 150.349 68.4409 152.763 75.3063L160.288 76.8678H151.755C149.135 69.4549 147.26 62.1939 146.094 56.2514L145.321 21.9423V20.542L145.983 20.5537Z",
    fill: "url(#paint12_linear_1646_251)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M149.827 49.753C150.929 49.6151 152.001 49.4423 153.056 49.2109C153.103 51.8543 154.92 56.3692 160.288 57.3271V63.0321C155.74 61.3677 152.241 57.465 151.152 52.6619C150.812 52.7383 150.472 52.8029 150.144 52.8613L147.161 51.8535L149.827 49.753Z",
    fill: "url(#paint13_linear_1646_251)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M147.16 51.8537C148.889 51.7509 150.325 51.4931 151.954 51.0889C152.428 56.5539 155.945 61.0486 160.287 63.0112V63.0322C155.727 61.3679 152.24 57.4652 151.151 52.6621C150.811 52.7384 150.471 52.7968 150.125 52.8615L147.16 51.8537Z",
    fill: "#7D0000"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M151.754 76.8682L152.762 75.3066L152.868 75.3214L151.754 76.8682Z",
    fill: "#FDEDE9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M146.721 20.542H145.321L146.035 21.7087L146.721 20.542Z",
    fill: "url(#paint14_linear_1646_251)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6802 83.4257L10.8733 80.2636L10.843 80.2114H9.64355L12.1607 84.5931V87.8712H13.1997V84.5931L15.7161 80.2114H14.5167L12.6802 83.4257Z",
    fill: "#D71921"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M16.249 87.8712H20.3223V86.8915H17.2888V84.1757H20.2335V83.1959H17.2888V81.192H20.3223V80.2114H16.249V87.8712Z",
    fill: "#D71921"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9746 87.8713H22.1125L23.012 85.7568H26.0549L26.9342 87.8713H28.0814L24.5744 79.6982L20.9746 87.8713ZM24.5526 82.1656L25.6414 84.777H23.4373L24.5526 82.1656Z",
    fill: "#D71921"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M32.838 82.3719C32.838 80.9186 31.9112 80.2114 30.0062 80.2114H28.8247V87.8712H29.8637V84.6001H29.912L32.1643 87.8712H33.4401L31.0537 84.509C32.1433 84.3408 32.838 83.5191 32.838 82.3719ZM29.8637 81.192H30.0062C31.1417 81.192 31.7991 81.3945 31.7991 82.4303C31.7991 83.2925 31.2656 83.6601 30.0163 83.6601H29.8644V81.192H29.8637Z",
    fill: "#D71921"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4499 83.4031L35.9507 83.1827C35.4616 82.9623 34.8518 82.6865 34.8518 82.1149C34.8518 81.5253 35.3487 81.0635 35.9826 81.0635C36.5193 81.0635 36.8658 81.2831 37.1766 81.822L37.2311 81.9171L38.0668 81.3812L38.0208 81.2956C37.6049 80.5261 36.8697 80.0845 36.0021 80.0845C34.7536 80.0845 33.812 80.9451 33.812 82.0861C33.812 83.2271 34.643 83.7014 35.4959 84.0884L35.9826 84.3011C36.668 84.6149 37.2607 84.8852 37.2607 85.6726C37.2607 86.4164 36.6213 87.0207 35.8339 87.0207C35.1244 87.0207 34.5535 86.4888 34.4452 85.7271L34.4281 85.6087L33.4102 85.8946L33.4296 85.9903C33.6796 87.2108 34.6314 88.0005 35.8541 88.0005C37.2257 88.0005 38.3004 86.9429 38.3004 85.5931C38.3004 84.3213 37.3861 83.8135 36.4499 83.4031Z",
    fill: "#D71921"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5172 78.0796H41.3232V79.339H42.5172V78.0796Z",
    fill: "#D71921"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4862 78.0796H43.2915V79.339H44.4862V78.0796Z",
    fill: "#D71921"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3117 79.29H50.1006V80.5331H51.3117V79.29Z",
    fill: "#D71921"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8355 81.8231H66.7218C66.7545 84.1798 66.7709 85.5023 66.7709 85.8099C66.7709 86.5195 66.2545 86.9065 65.6252 86.9065C65.0434 86.9065 64.5761 86.7617 64.2373 86.4712C63.8666 86.1651 63.6727 85.7126 63.6563 85.116C63.64 83.8411 63.64 82.9049 63.64 82.292H62.527C62.559 84.2928 62.5753 85.4712 62.5753 85.8099C62.5753 86.5358 62.1072 86.9065 61.4779 86.9065C60.2349 86.9065 59.6064 86.3099 59.5737 85.1152V82.2912H58.46C58.4763 83.0334 58.4763 83.6627 58.4763 84.1627V86.6799H56.1204H55.9101H54.2808H53.9093H52.7317C52.4248 86.6799 52.1179 86.5343 51.8438 86.2445C51.5214 85.9057 51.3601 85.4532 51.3438 84.8894C51.3274 83.873 51.3119 82.8558 51.3119 81.8231H50.1981C50.2464 84.5669 50.2464 85.8099 50.2137 85.5514C50.2137 85.9221 50.0525 86.2126 49.73 86.4385C49.4715 86.5997 49.1973 86.6807 48.8912 86.6807H47.6809H47.0836H46.0516C45.5999 86.6807 45.3733 86.4065 45.3733 85.873V80.7748H44.2603V81.5645H44.2276C43.9052 81.0482 43.2112 80.6455 42.4526 80.6455C41.8553 80.6455 41.3389 80.8714 40.9191 81.3067C40.3872 81.8395 40.1294 82.6144 40.1294 83.6308C40.1294 85.1643 40.7423 85.9392 41.969 85.9392H44.3413C44.325 87.1168 44.8904 87.7142 46.0524 87.7142H47.0844H47.6817H49.1981C50.0852 87.6659 50.9092 87.1978 51.2153 86.4065C51.2963 86.6487 51.4256 86.8746 51.6187 87.1012C51.9575 87.5039 52.3609 87.7142 52.8454 87.7142H53.91H54.2815H55.9109H56.1211H59.5589V86.9875C59.752 87.2936 59.9779 87.5203 60.2528 87.6659C60.5589 87.8271 60.9951 87.9081 61.5278 87.9081C62.5769 87.9081 63.2544 87.4891 63.545 86.6332C63.7872 87.1168 64.0777 87.4556 64.432 87.6659C64.7381 87.8435 65.1743 87.9393 65.7233 87.9393C66.9664 87.9393 67.8698 87.0849 67.8698 85.8099C67.8682 85.6962 67.8519 84.373 67.8355 81.8231ZM42.1949 84.9376C41.8078 84.9376 41.5492 84.792 41.4199 84.5023C41.3389 84.3239 41.2906 84.0661 41.2906 83.6946C41.2906 83.0007 41.4355 82.4524 41.7416 82.0809C42.0001 81.7265 42.3389 81.549 42.7424 81.549C43.3717 81.549 43.8725 81.887 44.2595 82.549L44.2751 84.9376H42.1949V84.9376Z",
    fill: "#D71921"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3252 21.0083C42.234 21.0083 34.8849 25.6743 31.4066 32.9571C33.43 32.7102 36.1731 32.7313 38.9403 33.8606C41.5704 30.1767 45.8018 27.9874 50.3252 27.9874C58.0349 27.9874 64.3068 34.2593 64.3068 41.969C64.3068 49.6786 58.0349 55.9513 50.3252 55.9513C43.9116 55.9513 38.3359 51.607 36.7666 45.3857C35.7782 43.2198 33.5477 41.7766 31.1068 41.7766C30.518 41.7766 29.9323 41.8607 29.3638 42.0266C29.3949 53.5588 38.7861 62.9297 50.3252 62.9297C58.9843 62.9297 66.4315 57.65 69.6223 50.1413C69.782 49.7659 69.9308 49.385 70.0686 48.9987C70.2952 48.2471 71.2688 46.2588 71.2844 41.7159C71.2921 39.5624 70.9284 37.8069 70.5748 36.5616C70.5079 36.3092 70.4354 36.0592 70.3591 35.8115C67.7228 27.2499 59.7413 21.0083 50.3252 21.0083Z",
    fill: "#231F20"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6445 45.1463H24.2833C25.6642 42.6603 28.2577 41.126 31.1074 41.126C34.8333 41.126 38.0304 43.7546 38.7586 47.3956L38.7859 47.4509C39.9386 50.3528 42.1995 52.7571 45.0259 54.1006C45.6279 52.5118 45.934 50.7625 45.934 48.8964C45.934 46.2141 45.3258 43.8262 44.1264 41.8013C43.0259 39.9438 41.6029 37.8884 39.395 36.7202H39.3942C33.7064 33.7115 27.5256 36.3907 27.1198 36.7272L26.1727 37.5099L26.471 36.3409L27.6806 31.8205L30.8185 31.6469C32.4384 28.8462 34.6565 26.4116 37.2882 24.5361L22.6446 25.1047L17.6445 45.1463Z",
    fill: "#D71921"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2567 65.465C47.555 67.4845 43.3672 68.5515 39.1397 68.5515C34.9059 68.5515 30.7119 67.4806 27.0047 65.4533C25.2897 65.366 24.0374 65.1067 23.4969 64.9945L23.3481 64.965C17.3534 63.757 11.101 59.355 8.20605 52.0449C12.0667 65.4875 24.4727 75.353 39.1397 75.353C53.6283 75.353 65.9104 65.7274 69.9277 52.5356C67.5553 58.5349 62.3855 64.5771 51.2567 65.465Z",
    fill: "#D71921"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1396 11C23.158 11 9.86803 22.7136 7.38668 38.0044C6.57046 42.5551 6.59383 49.655 12.0838 56.0492C14.8409 59.6567 18.7078 62.4278 23.6565 63.4247L23.8076 63.4558C24.8379 63.6677 27.5763 64.2316 31.3669 63.6825C34.9666 63.1607 36.1949 62.5711 37.9363 61.6926C35.786 60.2728 33.9113 58.5142 32.356 56.4557C30.5717 56.8693 28.3458 56.8786 25.7352 56.4853C21.133 55.7929 18.2163 53.2181 16.4141 50.2913C16.365 50.2087 16.3136 50.1215 16.263 50.0319C16.2225 49.9626 16.1828 49.8925 16.1431 49.8232C14.8432 47.4657 13.1407 42.9173 14.8183 35.9748C16.1384 31.5175 18.6455 27.5657 21.9843 24.4971L22.0232 24.3414L22.1603 24.3359C26.6604 20.2759 32.6154 17.8 39.1396 17.8C43.0361 17.8 46.7807 18.6676 50.2707 20.3802C50.2746 20.3802 50.2777 20.3802 50.2824 20.3802C56.1438 20.3802 61.5762 22.6412 65.5879 26.7534C66.9914 28.1919 68.183 29.8049 69.1379 31.5339C64.4633 19.5305 52.7785 11 39.1396 11Z",
    fill: "#D71921"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1646_251",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(145.326 73.7506) scale(3.11691 3.11829)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    stopColor: "#EC1C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#E81B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4239,
    stopColor: "#DB181F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6422,
    stopColor: "#C61319"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863,
    stopColor: "#A80B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920609"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1646_251",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(145.329 66.9675) scale(2.37837 2.38017)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    stopColor: "#EC1C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#E81B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4239,
    stopColor: "#DB181F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6422,
    stopColor: "#C61319"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863,
    stopColor: "#A80B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920609"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1646_251",
    x1: 130.365,
    y1: 65.4229,
    x2: 144.582,
    y2: 65.4229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C0405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8946,
    stopColor: "#870203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#860102"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1646_251",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(157.732 66.3662) rotate(180) scale(2.55541 2.55763)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    stopColor: "#EC1C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#E81B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4239,
    stopColor: "#DB181F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6422,
    stopColor: "#C61319"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863,
    stopColor: "#A80B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920609"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1646_251",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(132.923 66.3662) rotate(180) scale(2.55692 2.55913)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    stopColor: "#EC1C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2114,
    stopColor: "#E81B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4239,
    stopColor: "#DB181F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6422,
    stopColor: "#C61319"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863,
    stopColor: "#A80B10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#920609"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1646_251",
    x1: 145.886,
    y1: 52.51,
    x2: 145.886,
    y2: 49.9725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    stopColor: "#EC1C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2228,
    stopColor: "#E71B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4728,
    stopColor: "#D9181F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#C11319"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A30D11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1646_251",
    x1: 145.32,
    y1: 48.7051,
    x2: 130.365,
    y2: 48.7051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC1C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#E11921"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5145,
    stopColor: "#C51218"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9396,
    stopColor: "#96070A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F0508"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1646_251",
    x1: 130.365,
    y1: 48.7051,
    x2: 145.32,
    y2: 48.7051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2936,
    stopColor: "#610000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6404,
    stopColor: "#6F0001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#860102"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1646_251",
    x1: 144.626,
    y1: 21.7085,
    x2: 144.626,
    y2: 20.5423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    stopColor: "#CB171E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1879,
    stopColor: "#C6161D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3966,
    stopColor: "#B81318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6216,
    stopColor: "#A00D11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8565,
    stopColor: "#7F0607"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#670000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1646_251",
    x1: 130.365,
    y1: 56.1214,
    x2: 143.498,
    y2: 56.1214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0337,
    stopColor: "#A30D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1133,
    stopColor: "#B81117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2476,
    stopColor: "#D4171E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3642,
    stopColor: "#E61B22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4494,
    stopColor: "#EC1C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8185,
    stopColor: "#B81116"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A30D11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1646_251",
    x1: 146.064,
    y1: 65.4229,
    x2: 160.287,
    y2: 65.4229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C0405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8946,
    stopColor: "#870203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#860102"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1646_251",
    x1: 145.321,
    y1: 48.7051,
    x2: 160.287,
    y2: 48.7051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC1C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#E11921"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5145,
    stopColor: "#C51218"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9396,
    stopColor: "#96070A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F0508"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1646_251",
    x1: 160.287,
    y1: 48.7051,
    x2: 145.321,
    y2: 48.7051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2936,
    stopColor: "#610000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6404,
    stopColor: "#6F0001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#860102"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1646_251",
    x1: 160.287,
    y1: 56.1214,
    x2: 147.16,
    y2: 56.1214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0337,
    stopColor: "#A30D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1133,
    stopColor: "#B81117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2476,
    stopColor: "#D4171E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3642,
    stopColor: "#E61B22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4494,
    stopColor: "#EC1C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8185,
    stopColor: "#B81116"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A30D11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1646_251",
    x1: 146.021,
    y1: 21.7085,
    x2: 146.021,
    y2: 20.5423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    stopColor: "#CB171E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1879,
    stopColor: "#C6161D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3966,
    stopColor: "#B81318"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6216,
    stopColor: "#A00D11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8565,
    stopColor: "#7F0607"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#670000"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZagLogo2);
export default __webpack_public_path__ + "static/media/zag-logo-2.3e9e780978b2451eac39b2def9ed1670.svg";
export { ForwardRef as ReactComponent };